import { MessageQueueHeader } from "./types";

export const messageTableHeader: MessageQueueHeader[] = [
  { id: 'queue', label: 'Queue' },
  { id: 'messageType', label: 'Message type' },
  { id: 'receivedDate', label: 'Received Date' },
  { id: 'readDate', label: 'Read Date' },
  { id: 'sender', label: 'Sender' },
  { id: 'recipient', label: 'Recipient' },
];
